/** Firestore collection names — mirror services/firebase/config.ts COLLECTIONS. */
export const COLLECTIONS = {
  USERS: 'ksnap_users',
  MEALS: 'ksnap_meals',
  INSIGHTS: 'ksnap_insights',
  IMPORTED_RECIPES: 'ksnap_imported_recipes',
  DIARY_ENTRIES: 'ksnap_diary_entries',
  KETONE_READINGS: 'ksnap_ketone_readings',
  EXERCISE_LOGS: 'ksnap_exercise_logs',
} as const

/** Subcollections under ksnap_users/{uid}. */
export const SUBCOLLECTIONS = {
  WATER_LOGS: 'waterLogs',
  WEIGHT_HISTORY: 'weightHistory',
  FAVORITE_FOODS: 'favorite_foods',
} as const
